import { useQuery } from '@tanstack/react-query';
import type { DashboardKpis, ItemResponse } from '@proerp/shared';
import { apiRequest } from '@/lib/apiClient';

export const DASHBOARD_KPIS_KEY = ['dashboard', 'kpis'] as const;

/**
 * Kennzahlen des Start-Dashboards, serverseitig über ALLE Datensätze gerechnet
 * (`GET /v1/dashboard/kpis`). Ersetzt das Abzählen der ersten Listenseite im
 * Browser (≤ 200 Zeilen, Vorfall 2026-09-28). Kennzahlen- und Umsatz-Widget
 * teilen sich diese eine Abfrage.
 *
 * `null` in einem Feld heißt „für deine Rolle nicht freigegeben" — nie 0.
 *
 * `staleTime: 0`: Die Zahlen hängen an Belegen, Artikeln, Projekten und
 * Bestellungen; deren Mutationen invalidieren diesen Schlüssel nicht. Deshalb
 * beim Öffnen des Dashboards immer frisch holen (ein Aufruf, reine Aggregate).
 */
export function useDashboardKpis() {
  return useQuery({
    queryKey: DASHBOARD_KPIS_KEY,
    queryFn: () => apiRequest<ItemResponse<DashboardKpis>>('/v1/dashboard/kpis'),
    staleTime: 0,
  });
}
